import React from 'react';
import PropTypes from 'prop-types';

import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';

const ErrorPage = function () {

  return (
    <>
      <Header />
      <div id="container">
        <div id="contents">
          <div className="inner450">
            <p>
              エラーが発生しました。
              <br />
              {/* 下記リンクからトップページに戻ってください。 */}
              予約を最初からお願いします。
            </p>
            {/* <a href={topUrl}>トップに戻る</a> */}
            {/* <pre>{error.message}</pre> */}
            {/* <button onClick={resetErrorBoundary}>Try again</button> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

ErrorPage.propTypes = {
  error: PropTypes.shape({ message: PropTypes.string }).isRequired,
};

export default ErrorPage;
